import React from 'react';
import { Link } from 'react-router-dom';
import { formatPrice } from '../utils/helpers';
import './CourseCard.css';

function CourseCard({ course, featured }) {
  const cardClass = `course-card${featured ? ' course-card--featured' : ''}`;

  return (
    <Link to={course.route} className={cardClass}>
      {course.image ? (
        <img src={course.image} alt={course.name} className="course-card__image" />
      ) : (
        <div className="course-card__placeholder">
          <span className="course-card__placeholder-text">{course.name}</span>
        </div>
      )}
      <div className="course-card__body">
        <span className="course-card__category">{course.category}</span>
        <h3 className="course-card__name">{course.name}</h3>
        {featured && course.description && (
          <p className="course-card__description">{course.description}</p>
        )}
        <p className="course-card__instructor">{course.instructor}</p>
        <div className="course-card__footer">
          <div>
            {featured && course.courseCount && (
              <span className="course-card--featured course-card__badge">
                {course.courseCount} cursos
              </span>
            )}
            <span className="course-card__price">{formatPrice(course.price)}</span>
          </div>
          <span className="course-card__btn">
            {featured ? 'Saiba Mais' : 'Ver Curso'}
          </span>
        </div>
      </div>
    </Link>
  );
}

export default CourseCard;
